module.exports = __webpack_public_path__ + "static/media/trustpilot.777ee899.svg";